export default __webpack_public_path__ + "static/media/chicken.1ed9f753.png";